import * as React from 'react'
import { cn } from '@merels/ui'

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  ({ icon, className, type, title, ...props }, ref) => {
    return (
      <div className="relative inline-flex items-center justify-center group">
        <button
          ref={ref}
          type={type ?? 'button'}
          className={cn('inline-flex items-center justify-center', className)}
          {...props}
        >
          {icon}
        </button>
        {title && (
          <span className="absolute top-[125%] left-1/2 -translate-x-1/2 px-2.5 py-1 rounded-md bg-neutral-900/95 text-white border border-white/10 text-[10px] font-semibold shadow-lg whitespace-nowrap opacity-0 scale-95 group-hover:opacity-100 group-hover:scale-100 transition-all duration-100 pointer-events-none z-50">
            {title}
            <span className="absolute bottom-full left-1/2 -translate-x-1/2 -mb-[1px] border-[4px] border-transparent border-b-neutral-900/95" />
          </span>
        )}
      </div>
    )
  }
)
IconButton.displayName = 'IconButton'

